"use strict";function chooseSpaceDir$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.chooseSpaceDir$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.cspace.chooseSpaceDir";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.5.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.5.6"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"5.1.27"},_a)),exports.chooseSpaceDir$=chooseSpaceDir$,exports.default=chooseSpaceDir$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/cspace/chooseSpaceDir.js
// module id = 938
// module chunks = 106